import Swiper from 'swiper';
import { A11y, Pagination } from 'swiper/modules';

// Configure Swiper to use modules
Swiper.use([Pagination, A11y]);

const swiper = new Swiper('.swiper', {
  slidesPerView: 1,
  spaceBetween: 10,

  breakpoints: {
    1048: {
      slidesPerView: 1,
      spaceBetween: 70,
    },
  },

  pagination: {
    el: '.swiper-pagination',
    clickable: true,
  },
});

// MODAL

const openBtn = document.getElementById('openBtn');
const closeBtn = document.getElementById('closeBtn');
const modal = document.getElementById('modal');

let scrollPosition = 0;

function openModal() {
  scrollPosition = window.scrollY;

  modal.classList.add('show');

  document.body.style.position = 'fixed';
  document.body.style.top = `-${scrollPosition}px`;
  document.body.style.left = '0';
  document.body.style.right = '0';
  document.body.style.width = '100%';
  document.body.classList.add('modal-open');
}

function closeModal() {
  modal.classList.remove('show');

  document.body.style.position = '';
  document.body.style.top = '';
  document.body.style.left = '';
  document.body.style.right = '';
  document.body.style.width = '';
  document.body.classList.remove('modal-open');

  window.scrollTo(0, scrollPosition);
}

openBtn.addEventListener('click', openModal);

closeBtn.addEventListener('click', closeModal);

modal.addEventListener('click', (event) => {
  if (event.target === modal) {
    closeModal();
  }
});

document.addEventListener('keydown', (event) => {
  if (event.key === 'Escape' && modal.classList.contains('show')) {
    closeModal();
  }
});
